function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "4180DFF7-534A-48A5-A446-3366E1816046@3.00x");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "WHS---Dashboard-Expanded",
  transform: "translate(-298.000000, -529.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-3-Copy",
  transform: "translate(25.000000, 310.000000)"
}, React.createElement("g", {
  id: "Group-6-Copy-2",
  transform: "translate(0.000000, 205.000000)"
}, React.createElement("path", {
  d: "M273.420265,14.0028392 C273.17722,14.0295475 272.994852,14.237511 273.000111,14.4819623 L273.000111,30.5215291 C272.997705,30.6916598 273.08709,30.8499069 273.23404,30.9356744 C273.380989,31.0214419 273.562736,31.0214419 273.709686,30.9356744 C273.856635,30.8499069 273.946021,30.6916598 273.943615,30.5215291 L273.943615,14.4819623 C273.946541,14.3460996 273.890743,14.2155726 273.790509,14.1238095 C273.690276,14.0320463 273.555342,13.9879593 273.420265,14.0028392 Z M275.336757,14.0102104 C275.084901,14.0220531 274.886866,14.2298276 274.887119,14.4819623 L274.887119,21.5582418 C274.887595,21.6959527 274.948215,21.8265818 275.053073,21.9158528 C275.157931,22.0051238 275.296559,22.044125 275.432582,22.0226226 L287.226381,20.1356148 C287.455016,20.0994276 287.623628,19.9027139 287.624422,19.6712339 L287.624422,16.3689702 C287.623628,16.1374902 287.455016,15.9407765 287.226381,15.9045893 L275.432582,14.0175815 C275.400975,14.011869 275.368867,14.0093992 275.336757,14.0102104 Z M275.830623,15.0347966 L279.604638,15.6392289 L279.604638,20.4009752 L275.830623,21.0054075 L275.830623,15.0347966 Z M280.548142,15.7866513 L283.378654,16.2362899 L283.378654,19.8039142 L280.548142,20.2535528 L280.548142,15.7866513 Z M284.322158,16.3910835 L286.680918,16.7670109 L286.680918,19.2731932 L284.322158,19.6491206 L284.322158,16.3910835 Z",
  id: "Shape"
})))));

var SvgWind = function SvgWind(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWind, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WIND.41c3e9ee.svg";
export { ForwardRef as ReactComponent };